export default __webpack_public_path__ + "static/media/beachBlaze1.54d73ef6.jpg";